import {
  formatDateToString,
  formatToCurrencyType,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import moment from "moment";
import React from "react";
import {CURRENCY_LOCALE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    title: "Item nội dung",
    dataIndex: "noiDung",
    show: true,
    width: 300,
  },
  {
    dataIndex: "donGia",
    key: "donGia",
    title: "Giá tiền",
    show: true,
    render: (value, record, index) => {
      return <>{formatToCurrencyTypeToFixed(value, 4)}</>;
    },
    width: 240,
  },
  {
    dataIndex: "soLuong",
    key: "soLuong",
    title: "Số lượng",
    align: "right",
    show: true,
    width: 120,
    rules: [{required: true, message: "Chưa nhập số lượng"}],
  },
  {
    dataIndex: "vat",
    key: "vat",
    title: "VAT (%)",
    align: "right",
    show: true,
    width: 120,
  },
  {
    dataIndex: "thanhTien",
    key: "thanhTien",
    title: "Thành tiền",
    show: true,
    width: 240,
    render: (value, record, index) => {
      return <>{formatToCurrencyTypeToFixed(value, 4)}</>;
    },
    align: "right",
  },
  {
    dataIndex: "nganSach",
    key: "nganSach",
    title: "Dòng ngân sách",
    show: true,
    width: 200,
    render: (value, record, index) => {
      return <>{formatToCurrencyTypeToFixed(value, 4)}</>;
    },
    align: "right",
  },
  {
    dataIndex: "nguonThanhToan",
    key: "nguonThanhToan",
    title: "Nguồn thanh toán",
    show: true,
    width: 200,
  },
  {
    dataIndex: "chiPhiChinh",
    key: "chiPhiChinh",
    title: "Chi phí chính",
    show: true,
    width: 200,
  },
  {
    dataIndex: "duAn",
    key: "duAn",
    title: "Dự án",
    show: true,
    width: 200,
    rules: [{required: true, message: "Chưa nhập dự án"}],
  },
];
export {columns};
